import React from 'react';
import { useRefFromState } from './useRefFromState';

export const useRefCallback = <T extends (...args: any[]) => void>(callback?: T): T => {
  const callbackRef = useRefFromState(callback);

  const returnedCallback = React.useCallback(
    (...args: any[]) => {
      return callbackRef.current?.(...args);
    },
    [callbackRef]
  );

  return returnedCallback as T;
};
